import { createSlice } from "@reduxjs/toolkit";

const orgSlice = createSlice({
  name: "org",
  initialState: {
    list: [],
    id: null,
    token: null
  },
  reducers: {
    setOrgList: (state, action) => {
      return {
        ...state,
        list: action.payload,
      };
    },
    setOrgId: (state, action) => {
      return {
        ...state,
        id: action.payload,
      };
    },
    setOrgToken: (state, action) => {
      return {
        ...state,
        token: action.payload,
      };
    },
  },
});

export const { setOrgList, setOrgId, setOrgToken} = orgSlice.actions;

export default orgSlice.reducer;
